'use es6';

import I18n from 'I18n';
import * as ActionTypes from './ActionTypes';
import { add } from '../api/Folders';
import { getTrackingMeta } from './tracking';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { getFoldersById } from '../selectors/Folders';
import { getAncestors } from '../utils/FoldersAndFiles';
import { jsx as _jsx } from "react/jsx-runtime";
export function receiveFolderDelete(folder) {
  const keyBase = `FileManagerCore.notifications.deleteFolder.success`;
  return {
    type: ActionTypes.DELETE_FOLDER_SUCCEEDED,
    folder,
    meta: {
      notification: {
        type: 'success',
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${keyBase}.title`
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${keyBase}.message`,
          options: {
            folder: folder.get('name')
          }
        })
      }
    }
  };
}
export function receiveRenameFolder(folder) {
  return {
    type: ActionTypes.RENAME_FOLDER_SUCCEEDED,
    folder
  };
}
function receiveAddFolder(folder, state) {
  const foldersById = getFoldersById(state);
  const folderAncestors = [{
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "FileManagerCore.rootFolder"
    })
  }].concat(getAncestors(folder, foldersById).toArray().map(ancestor => {
    return {
      name: ancestor.get('name')
    };
  }));

  // We should have at least one parent, but if not, fall back to "Home" folder
  let firstParent = folderAncestors[folderAncestors.length - 2];
  if (!firstParent) {
    firstParent = {
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerCore.rootFolder"
      })
    };
  }
  return {
    type: ActionTypes.ADD_FOLDER_SUCCEEDED,
    meta: Object.assign({}, getTrackingMeta('fileManagerManageFolders', 'create new folder'), {
      notification: {
        type: 'success',
        titleText: I18n.text('FileManagerCore.notifications.addFolder.success.title'),
        message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: 'FileManagerCore.notifications.addFolder.success.message_jsx',
          elements: {
            UILink
          },
          options: {
            href: `/files/${PortalIdParser.get()}?folderId=${folder.get('id')}`,
            folderName: folder.get('name'),
            parentFolderName: firstParent.name
          }
        })
      }
    }),
    folder
  };
}
export function addFolder({
  parentId,
  name
}) {
  return (dispatch, getState) => {
    return add({
      parentId,
      name
    }).then(data => {
      dispatch(receiveAddFolder(data, getState()));
      return data;
    }, error => {
      dispatch({
        type: ActionTypes.ADD_FOLDER_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: error.status === 403 ? 'FileManagerCore.notifications.addFolder.noAccess.title' : 'FileManagerCore.notifications.addFolder.error.title'
            }),
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: error.status === 403 ? 'FileManagerCore.notifications.addFolder.noAccess.message' : 'FileManagerCore.notifications.addFolder.error.message',
              options: {
                folderName: name
              }
            })
          },
          error
        }
      });
      return error;
    });
  };
}